import {make} from 'vuex-pathify'

const state = {
  formComponentsNoUserEditableValue: [
    'Checkbox',
    'Switch',
    'GlobalUserPreference'
  ],
  formComponentsNoPlaceholder: [
    'Switch',
    'Tags',
    'Checkbox',
    'Radio'
  ],
  formComponentsNoDefault: [
    'Checkbox',
    'Switch',
    'Tags',
    'GlobalUserPreference'
  ],
  formComponentsWithValues: [
    'Radio',
    'Select',
    'SelectMultiple',
    'Tags'
  ],
  taskFormComponents: [
    {value: 'Input', label: 'Input'},
    {value: 'Checkbox', label: 'Checkbox'},
    {value: 'Radio', label: 'Radio'},
    {value: 'Select', label: 'Select'},
    {value: 'PriceRule', label: 'PriceRule'},
    {value: 'InvoiceableTaskPriceRule', label: 'Invoiceable Task PriceRule'},
    {value: 'SelectMultiple', label: 'Select Multiple'},
    {value: 'Date', label: 'Date'},
    {value: 'Numeric', label: 'Numeric'},
    {value: 'Currency', label: 'Currency'},
    {value: 'Tags', label: 'Tags'},
    {value: 'Switch', label: 'Switch'},
    {value: 'TimeTracking', label: 'Time Tracking'},
    {value: 'TimeTrackingSelect', label: 'Time Tracking Select'},
    {value: 'TimePicker', label: 'Time Picker'},
    {value: 'TimeSelect', label: 'Time Select'},
    {value: 'HTML', label: 'HTML'}
  ],
  inspectorAppFormComponents: [
    {value: 'Input', label: 'Input'},
    {value: 'Checkbox', label: 'Checkbox'},
    {value: 'GlobalUserPreference', label: 'User Preference'}
  ]
}

const getters = make.getters(state)

export default {
  namespaced: true,
  state,
  getters
}
